import { render } from "./flowDtl.vue?vue&type=template&id=36f9ad38&scoped=true"
import script from "./flowDtl.vue?vue&type=script&lang=js"
export * from "./flowDtl.vue?vue&type=script&lang=js"

import "./flowDtl.vue?vue&type=style&index=0&id=36f9ad38&lang=scss&scoped=true"
import "./flowDtl.vue?vue&type=style&index=1&id=36f9ad38&lang=scss"

import exportComponent from "D:\\客云\\newQsProject\\qs3_pc_portal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f9ad38"]])

export default __exports__